import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import {api, CycleFetch} from 'helpers/api';
import {List, Map} from 'immutable';
import _ from 'lodash';

import Page from 'components/ui/page';
import * as storage from 'utils/storage';

import {connect} from 'react-redux';
import {getTelematics, getTelematicsTotalCount, getTelematicsWithDevices} from 'store/reducers/maps';

import Leaflet from './leaflet';

import GlobalLoaderComponent from "components/ui/global-loader";
import {getVehicleList, getVehicleListGuest} from "store/reducers/vehicles/vehicles";
import debounce from 'throttle-debounce/debounce';
import "components/ui/page-modal.less";

import './map.less';
import {getDictionaryList} from "store/reducers/dictionary";
import {getGuestToken} from "store/reducers/auth";
import {listLayers, listUserGeoObjectsByLayers, listUserGeoObjectsMO} from "store/reducers/geo/user-objects";
import MapGeojson from "components/ui/map/base/geojson";
import {getCarriers} from "store/reducers/organizational_units/carriers";
import GarbageObjectsLayer from "components/ui/map/layers/garbage-objects";
import StopPointsMtaLayer from "components/ui/map/layers/stop-points-mta";
import Select from 'components/ui/select';
import {getStopPointRouteRuns, getStopPointRoutes} from "store/reducers/routes/routes";
import PageModal from "components/ui/page-modal";
import ModalTopMenuButtons from "components/ui/modal/modal-top-menu-buttons";
import ModalTopMenuButton from "components/ui/modal/modal-top-menu-button";
import Block from "components/ui/form/block";
import LoaderComponent from "components/ui/loader";
import moment from "moment";
import formats from "dictionaries/formats";
import Accordion from "components/ui/accordion/accordion";
import AccordionItem from "components/ui/accordion/accordion-item";
import {formatDistance, formatTime} from "helpers/functions";
import ModalTopMenuListItem from "components/ui/modal/modal-top-menu-list-item";
import ModalTopMenuList from "components/ui/modal/modal-top-menu-list";
import {print} from "helpers/print";
import $ from 'jquery';
import classNames from 'classnames';
import {printSchedule} from "components/modules/map/print/index";
import L from 'leaflet';
import {getTabletWorkSummary} from 'store/reducers/reports/tablet';
import {getTasks, getTasksGuests, getGeometryFromContract} from 'store/reducers/kurs/tasks';

let lastWsTimestamp = null;

@connect(state => ({}), {
    getTelematicsWithDevices,
    getGeometryFromContract,
    getTabletWorkSummary,
    getTasks,
    getTasksGuests,
    getVehicleList,
    getVehicleListGuest,
    getDictionaryList,
    listLayers,
    listUserGeoObjectsByLayers,
    getCarriers,
    getStopPointRoutes,
    getTelematics,
    listUserGeoObjectsMO,
    getTelematicsTotalCount,
    getStopPointRouteRuns,
    getGuestToken
})

export default class MapComponent extends Component {

    map = null;

    zoomDebounce = debounce(1000, ::this.onZoomLoad);

    _cycleFetch = null;
    _vehiclesCycleFetch = null;

    initialState = {
        loading: false,
        defaultPolygonStyle: null,
        telematics: new Map({}),
        clusters: [],
        sourceType: 't1sync',
        vehicles: {},
        vehicle_models: [],
        vehicle_marks: [],
        vehicle_types: [],
        user_geo_objects: [],
        carriers: {},
        activeStopPoint: null,
        routes: [],
        isRoutesLoading: false,
        requestIndex: 0,
        totalCount: null,
        stopPointTime: null,
        stopPointRouteRuns: {},
        stopPointRoutePages: {},
        mu: null,
        muTasks: null,
        muTasksObjects: null,
        button_goBack: false,
        faqOpened: true,
        selected_work_type: 'all',
        selected_communal_uuid: null,
        selector_municipalities: [],
        customDateSelected: 1,
        computedGeometry: null,
        filter_work_types: null,
        bnso_numbers: null,
        token: null,
        bluePolygonsRoadPartUuid: null,
        isLegendShowBlue: false,
        contracts: null,
        contractsToRender: [],
        isNeedContractRender: false,
    };
    state = _.cloneDeep(this.initialState);

    async componentWillMount() {
        if (window.RNIS_SETTINGS.CITY_MURMANSK) {
            await this.getGuestTokenFirst();
        }
        this.setState({
            type: this.props.params.type,
        });
        this.init();
    }

    init(props = null) {
        props = props || this.props;

        this.loadDictionaries([
            'work_types',
            'vehicle_models',
            'vehicle_marks',
            'vehicle_types',
        ], props.params.type);

        if (props.params.type === 'garbage' || props.params.type === 'road') {
            this.loadMo(props.params.type);
        }

        this._countCycleFetch = new CycleFetch(() => {
            return this.loadTelematicsCount();
        }, () => {

        }, 30000);
        this._countCycleFetch.run();

        /*if (this._vehiclesCycleFetch) {
            this._vehiclesCycleFetch.stop();
            delete this['_vehiclesCycleFetch'];
        }
        this._vehiclesCycleFetch = new CycleFetch(() => {
            return this.loadVehicles(props.params.type, false);
        }, () => {
        }, 10000);
        this._vehiclesCycleFetch.run();*/

        if (this._cycleFetch) {
            this._cycleFetch.stop();
            delete this['_cycleFetch'];
        }
        this._cycleFetch = new CycleFetch(
            () => {
                if (!this.map) {
                    if ((this.state.telematics.size > 0) || (this.state.clusters.length > 0)) {
                        this.setState({telematics: new Map({}), clusters: [], loading: false});
                    }
                    return null;
                }

                const type = props.params.type;
                let deviceAll = false;
                if (window.RNIS_SETTINGS.CITY_OMSK && type === 'bus') {
                    deviceAll = true;
                }
                const boundingBox = this.map.getBoundingBox();
                const mapSize = this.map.getMapSize();

                let promise;
                if (location.pathname.includes('map/road')) {
                    if (this.state.bnso_numbers) {
                        promise = this.props.getTelematicsWithDevices(this.state.bnso_numbers, this.state.sourceType, boundingBox, mapSize, this.map.getZoom())
                    } else {
                        promise = this.props.getTelematics(this.logicForDetectDevicesParam(deviceAll), this.state.sourceType, boundingBox, mapSize, this.map.getZoom());
                    }
                } else {
                    if (!this.state.bnso_numbers) {
                        promise = this.props.getTelematics(this.logicForDetectDevicesParam(deviceAll), this.state.sourceType, boundingBox, mapSize, this.map.getZoom());
                    }
                }
                promise.then((response) => {
                    if (type !== this.props.params.type) {
                        if ((this.state.telematics.size > 0) || (this.state.clusters.length > 0)) {
                            this.setState({telematics: new Map({}), clusters: [], loading: false});
                        }
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                resolve();
                            }, 5000);
                        });
                    }
                    let telematics = {};
                    let clusters = [];

                    _.each(_.get(response, 'payload.items', []), (item) => {
                        const latitude = item[0];
                        const longitude = item[1];
                        const type = item[2];

                        if (type === 'cluster') {
                            const info = item[3];
                            clusters.push([
                                latitude,
                                longitude,
                                info,
                            ]);
                        } else {
                            const deviceId = item[3];
                            const course = item[4];
                            const speed = item[5];
                            const type = item[6];
                            const time = item[7];

                            telematics[deviceId] = [
                                latitude,
                                longitude,
                                course,
                                speed,
                                type,
                                time,
                            ];
                        }

                    });
                    this.setState({telematics: new Map(telematics), clusters, loading: false});
                }, () => {
                    this.setState({loading: false});
                });
                return promise;
            },
            () => {
            }, 10000);

        this._cycleFetch.run();
        if (props.params.type === 'road') {
            if (window.RNIS_SETTINGS.CITY_MURMANSK) {
                this.loadMu();
                this.loadMuRoadParts();
            }
            this.loadRuads();
        }

    }

    componentWillUnmount() {
        if (this._countCycleFetch) {
            this._countCycleFetch.stop();
            delete this['_countCycleFetch'];
        }
        //this._vehiclesCycleFetch.stop();
        //delete this['_vehiclesCycleFetch'];

        // this._cycleFetch.stop();
        // delete this['_cycleFetch'];
    }

    logicForDetectDevicesParam(deviceAll) {
        if (deviceAll) {
            return 'all'
        }
        if (this.props.params.type === 'bus') {
            return 'kiutr'
        }
        if (this.props.params.component === 'kiutr') {
            return 'kiutr'
        }
        return this.props.params.type
    }

    async loadTelematicsCount() {
        if (this.map && this.map.getZoom() < 14) {
            this.loadTelematics(false, true);
        }
        if (!this.state.bnso_numbers) {
            const response = await this.props.getTelematicsTotalCount();

            if (response.isOk) {
                await this.setState({
                    totalCount: response.payload.count,
                });

                if (this.state.clusters.length === 1) {
                    let clusters = this.state.clusters;
                    clusters[0][2].bus = response.payload.count;
                    this.setState({clusters});
                }
            }
        }
    }

    onTelematicsUpdate({headers: {timestamp}, payload}) {
        const time = moment(timestamp);
        if (lastWsTimestamp && time.isBefore(lastWsTimestamp)) {
            return;
        }

        lastWsTimestamp = time;
        let telematics = this.state.telematics.toObject();
        let clusters = this.state.clusters;

        _.each(payload.data.device.changed, (item) => {
            const latitude = item[0];
            const longitude = item[1];
            const deviceId = item[3];
            const course = item[4];
            const speed = item[5];
            const type = item[6];
            const time = item[7];
            const forecast = item[14];

            telematics[deviceId] = [
                latitude,
                longitude,
                course,
                speed,
                type,
                time,
                forecast,
            ];
        });

        _.each(payload.data.device.deleted, (data) => {
            delete telematics[data[2]];
        });

        const length = clusters.length;

        _.each(payload.data.cluster.deleted, (data) => {
            _.remove(clusters, (cluster) => {
                return (_.round(cluster[0], 6) === _.round(data[0], 6)) && (_.round(cluster[1], 6) === _.round(data[1], 6));
            });
        });

        _.each(payload.data.cluster.changed, (item) => {
            const latitude = item[0];
            const longitude = item[1];
            const info = item[3];

            clusters.push([
                latitude,
                longitude,
                info,
            ]);
        });

        this.setState({telematics: new Map(telematics), clusters});
    }

    async loadTelematics(initial = false, withoutWs = false) {
        if (!this.map) {
            if ((this.state.telematics.size > 0) || (this.state.clusters.length > 0)) {
                this.setState({telematics: new Map({}), clusters: [], loading: false});
            }
            return;
        }

        const requestIndex = this.state.requestIndex + 1;
        this.setState({
            requestIndex,
        });

        const type = this.props.params.type;
        const boundingBox = this.map.getBoundingBox();
        const mapSize = this.map.getMapSize();
        if (!withoutWs) {
            api.telematics.telematicsUpdateUnsubscribe();
        }
        /*api.telematics.telematicsUpdateSubscribe({
            bounding_box: this.map.getBoundingBox(),
        }, ::this.onTelematicsUpdate);
        api.telematics.filtersUpdate('com.rnis.telematics.action.telematics.portal.update', {
            zoom: this.map.getZoom(),
            //bounding_box: this.map.getBoundingBox(),
        });*/

        let response = {
            isOk: true,
            payload: {
                items: [],
            },
        };
        if (!withoutWs && this.map.getZoom() >= 14 && (this.props.params.type === 'bus')) {
            api.telematics.telematicsUpdateSubscribe({
                bounding_box: this.map.getBoundingBox(),
            }, ::this.onTelematicsUpdate);
        }

        let deviceAll = false;
        if (window.RNIS_SETTINGS.CITY_OMSK && type === 'bus') {
            deviceAll = true;
        }

        if (location.pathname.includes('map/road')) {
            if (this.state.bnso_numbers) {
                response = await this.props.getTelematicsWithDevices(this.state.bnso_numbers, this.state.sourceType, boundingBox, mapSize, this.map.getZoom())
            } else {
                response = await this.props.getTelematics(this.logicForDetectDevicesParam(deviceAll), this.state.sourceType, boundingBox, mapSize, this.map.getZoom());
            }
        } else {
            if (!this.state.bnso_numbers) {
                response = await this.props.getTelematics(this.logicForDetectDevicesParam(deviceAll), this.state.sourceType, boundingBox, mapSize, this.map.getZoom());
            }
        }

        if (this.state.requestIndex !== requestIndex) {
            return;
        }
        let telematics = {};
        let clusters = [];

        const items = _.get(response, 'payload.items', []);
        _.each(items, (item) => {
            const latitude = item[0];
            const longitude = item[1];
            const type = item[2];

            if (type === 'cluster') {
                const info = item[3];
                if ((items.length === 1) && (this.props.params.type === 'bus')) {
                    info.bus = this.state.totalCount;
                }
                clusters.push([
                    latitude,
                    longitude,
                    info,
                ]);
            } else {
                const deviceId = item[3];
                const course = item[4];
                const speed = item[5];
                const type = item[6];
                const time = item[7];

                telematics[deviceId] = [
                    latitude,
                    longitude,
                    course,
                    speed,
                    type,
                    time,
                    item[14],
                ];
            }

        });
        this.setState({telematics: new Map(telematics), clusters, loading: false});

        /*initial && setTimeout(() => {
            this.loadTelematics(initial);
        }, 4000);*/
    }

    setVehicleType() {

    }

    async componentWillUpdate(props, state) {
        if (props.params.type !== state.type) {
            this.map = null;
            await this.setState({
                type: props.params.type,
            });
            await this.setState(this.initialState);
            this.init(props);
            if (window.RNIS_SETTINGS.CITY_OMSK) {
                this.loadVehicles(props.params.component);
            } else {
                this.loadVehicles(props.params.type);
            }
        }
    }

    async componentDidMount() {
        if (window.RNIS_SETTINGS.CITY_OMSK && window.RNIS_SETTINGS.telematicsFilterVehicles) {
            const bnso_numbers = await this.getActualDevicesForGuestUser();
            if (bnso_numbers) {
                await this.setState({
                    bnso_numbers: bnso_numbers
                });
            }
        }
        this.loadCarriers();
    }

    async getGuestTokenFirst() {
        const responseToken = await this.props.getGuestToken();
        if (responseToken.isOk) {
            const token = responseToken.payload.token;
            storage.set('user', responseToken.payload);
            await this.setState({
                token: token
            });
        }
    }

    async getActualDevicesForGuestUser() {
        if (storage.get('user').token) {
            const meta = {
                filters: {today: true, onlyUuid: true},
                response_data: ['items/uuid', 'items/number', 'items/resources', 'items/status_uuid']
            };
            const responseGuestTasks = await this.props.getTasksGuests(meta, {}, storage.get('user').token);
            if (responseGuestTasks.isOk) {
                const vehiclesInWork = responseGuestTasks.payload.items.filter(item => item.status_uuid === 'ef9d7f2a-f45e-11e7-9db9-7d3c938a1130');
                const vehiclesBaseUuid = vehiclesInWork.map(item => {
                    return item.resources.map(item => item.base_vehicle_uuid)
                });
                const responseGuestVehicleList = await this.props.getVehicleListGuest({
                    filters: {
                        withUuid: _.uniq(vehiclesBaseUuid.flat()),
                    },
                });
                if (responseGuestVehicleList.isOk) {
                    return responseGuestVehicleList.payload.items.map(item => {
                        if (item && item.current_bnso && item.current_bnso.bnso_number) {
                            return item.current_bnso.bnso_number
                        } else {
                            console.info("Нет bnso_number", item);
                        }
                    });
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    async loadCarriers() {
        const response = await this.props.getCarriers({
            filters: {
                withComponent: 'kiutr',
                short: true,
            },
        });
        this.setState({loading: false});
        if (response.isOk) {
            this.setState({
                carriers: _.mapValues(_.keyBy(response.payload.items, 'uuid'), 'name'),
            });
        } else {
            response.showErrors();
        }
    }

    async loadRuads() {
        const response = await this.props.listLayers();

        if (response.isOk) {
            const layer = _.find(response.payload.items, {title: 'Региональные управления автомобильными дорогами (РУАД)'});
            if (layer) {
                this.loadUserGeoObjects(layer.uuid);
            }
        } else {
            response.showErrors();
        }
    }

    async loadUserGeoObjects(uuid) {
        const response = await this.props.listUserGeoObjectsByLayers({
            items: [uuid],
        });
        if (response.isOk) {
            this.setState({
                user_geo_objects: response.payload.items,
            });
        } else {
            response.showErrors();
        }
    }

    getTypes(type) {
        switch (type) {
            case 'bus':
                return [
                    'bus',
                    'trolleybus',
                    'tram',
                ];
            case 'children':
                return [
                    'school',
                ];
            case 'road':
                return [
                    'road',
                ];
            case 'waste':
                return [
                    'trash',
                ];
        }
    }

    async loadVehicles(type = 'bus', forceNext = true) {
        if (type === 'bus') {
            type = 'kiutr';
        }
        const response = await this.props.getVehicleList({
            pagination: {
                page: 1,
                limit: 10000,
            },
            filters: {
                withActiveBnso: true,
                withComponent: type,
            },
        });

        if (response.isOk) {
            let _type = this.props.params.type;
            if (_type === 'bus') {
                _type = 'kiutr';
            }
            if (_type !== type) {
                return;
            }
            await this.setState({
                vehicles: _.keyBy(response.data.payload.items, 'current_bnso.bnso_number'),
            });
            //this.loadCarriers(_.uniq(_.filter(_.map(response.data.payload.items, 'unit_uuid'))));
            forceNext && this.loadTelematics();//this._cycleFetch.forceNext();
        } else {
            response.showErrors();
            this.setState({loading: false});
        }
    }

    render() {
        const loader = this.state.loading === true
            ? <GlobalLoaderComponent block={false} style={{zIndex: 99999}}/>
            : '';

        let title =`Портал ${window.RNIS_SETTINGS.SHORT_TITLE}`;

        if (this.props.params.type === 'bus') {
            title = `Портал ${window.RNIS_SETTINGS.SHORT_TITLE} ${!window.RNIS_SETTINGS.CITY_OMSK ? '| ТС в работе:' + (this.state.totalCount !== null) ? this.state.totalCount : '-' : ''}`;
        }

        if (this.props.params.type !== 'bus' && window.RNIS_SETTINGS.CITY_OMSK) {
            title = `Портал ${window.RNIS_SETTINGS.SHORT_TITLE}`;
        }

        if (window.RNIS_SETTINGS.CITY_MURMANSK) {
            title = 'Работа коммунальной техники сегодня';
        }

        const focusRoute = (this.map && this.map.refs.map) ? this.map.refs.map.getWrappedInstance().state.focusRoute : null;

        return (
            <Page key={this.props.params.type} pageId="Main" title={title} className={classNames('_fullheight', {
                'full-schedule-route': this.state.fullScheduleRoute,
            })}>
                {loader}
                {((this.state.telematics.size > 0) || (this.state.clusters.length > 0)) ? (
                    <div className="has-markers"/>
                ) : null}
                <Leaflet
                    ref={n => {
                        if (!this.map) {
                            this.map = n;
                            this.loadTelematics(true);
                        }
                    }}
                    {...this.props}
                    telematics={this.state.telematics}
                    vehicles={this.state.vehicles}
                    clusters={this.state.clusters}
                    onClusterRendered={::this.onClusterRendered}
                    onZoom={::this.onZoomLoad}
                    data={{
                        vehicle_models: this.state.vehicle_models,
                        vehicle_marks: this.state.vehicle_marks,
                        carriers: this.state.carriers,
                    }}
                    onStopPointClick={(focusRoute && /transit/.test(focusRoute)) ? ::this.onStopPointClick : null}
                    onStopPointScheduleClick={::this.onStopPointScheduleClick}
                    onStopPointFromHereClick={::this.onStopPointFromHereClick}
                    onStopPointToHereClick={::this.onStopPointToHereClick}
                    selectedStopPoint={_.get(this.state.activeStopPoint, 'uuid')}
                    selectedStopPoints={_.get(this.state.fullScheduleRouteRun, 'stop_points', [])}
                >
                    {(this.props.params.type === 'road') ? this.state.user_geo_objects.map(::this.renderUserGeoObject) : null}
                    {(this.props.params.type === 'garbage') ? this.renderGarbageObjects() : null}
                    {this.renderMo()}
                    {window.RNIS_SETTINGS.CITY_MURMANSK && this.state.mu && this.renderMu()}
                    {window.RNIS_SETTINGS.CITY_MURMANSK && this.state.muTasks && this.renderMuRoadParts()}
                    {window.RNIS_SETTINGS.CITY_MURMANSK && this.state.isNeedContractRender && this.state.contractsToRender.length && this.renderMuContracts()}
                    {this.renderRoute()}
                </Leaflet>
                {window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderWorkTypeSelect() : null}
                {window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderMunicipalities() : null}
                {window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderCustomDatePicker() : null}
                {location.pathname.includes('map/road') && window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderLegend() : null}
                {this.renderStopPointModal()}
            </Page>
        );
    }

    async onStopPointScheduleClick(stopPoint) {
        await this.map.refs.map.getWrappedInstance().closeRouting();
        await this.closeStopPoint();

        const stopPointTime = moment();
        await this.setState({
            stopPointTime,
            activeStopPoint: stopPoint,
            routes: [],
        });

        this.loadRoutes();
    }

    async onStopPointFromHereClick(stopPoint) {
        await this.closeStopPoint();
        await this.map.refs.map.getWrappedInstance().closeRouting();
        await this.map.refs.map.getWrappedInstance().routing();
        this.map.refs.map.getWrappedInstance().reverseGeocode(stopPoint.latitude, stopPoint.longitude, 'from');
    }

    async onStopPointToHereClick(stopPoint) {
        await this.closeStopPoint();
        await this.map.refs.map.getWrappedInstance().closeRouting();
        await this.map.refs.map.getWrappedInstance().routing();
        this.map.refs.map.getWrappedInstance().reverseGeocode(stopPoint.latitude, stopPoint.longitude, 'to');
    }

    async onStopPointClick(stopPoint) {
        const stopPointTime = moment();
        const focusRoute = this.map.refs.map.getWrappedInstance().state.focusRoute;
        if (focusRoute && /transit/.test(focusRoute)) {
            this.map.refs.map.getWrappedInstance().onStopPointClick(stopPoint);
            return;
        }

        await this.setState({
            stopPointTime,
            activeStopPoint: stopPoint,
            routes: [],
        });

        this.loadRoutes();
    }

    async loadRoutes() {
        this.setState({isRoutesLoading: true});
        const response = await this.props.getStopPointRoutes(this.state.activeStopPoint.uuid);
        this.setState({isRoutesLoading: false});

        if (response.isOk) {
            this.setState({
                routes: _.sortBy(response.payload.items, 'number'),
            });

            _.each(response.payload.items, (route) => {
                if (route.time !== -1) {
                    this.loadStopPointRouteRuns(route.uuid);
                }
            });
        } else {
            response.showErrors();
        }
    }

    toggleFaq() {
        this.setState({
            faqOpened: !this.state.faqOpened,
        });
    }

    renderMuLegend() {
        return (
            <div className="legend">
                <div className={classNames('faq', {
                    'expand': this.state.faqOpened,
                })}>
                    <div className={classNames('faq__btn', {
                        'faq__btn_opened': this.state.faqOpened,
                    })} onClick={::this.toggleFaq}></div>
                    <div className="faq__inner big">
                        <div className="faq__title">Расшифровка обозначений на графике</div>
                        <div className="faq__content">
                            <div className="faq__row faq__row_short">
                                <b>%</b> - процент выполненных заданий за сегодняшний день (фактическое выполнение  работ относительно плана).
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderLegend() {
        return (
            <div className="legend">
                <div className={classNames('faq', {
                    'expand': this.state.faqOpened,
                })}>
                    <div className={classNames('faq__btn', {
                        'faq__btn_opened': this.state.faqOpened,
                    })} onClick={::this.toggleFaq}></div>
                    <div className="faq__inner big">
                        <div className="faq__title">Расшифровка обозначений на графике</div>
                        <div className="faq__content">
                            <div className="faq__row">
                                Работа выполнена
                                <div className="indicators indicators_green2"/>
                            </div>
                            <div className="faq__row">
                                Выполнено частично
                                <div className="indicators indicators_yellow" />
                            </div>
                            <div className="faq__row">
                                Работа не выполнена
                                <div className="indicators indicators_red2"/>
                            </div>
                            <div className="faq__row">
                                Работа запланирована/выполняется
                                <div className="indicators indicators_gray2"/>
                            </div>
                            <div className="faq__row">
                                Объекты по подрядам
                                <div className="indicators indicators_blue"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderUserGeoObject(object) {
        return (
            <MapGeojson
                key={object.uuid}
                map={this.map.refs.map}
                leafletMap={this.map.refs.map.getWrappedInstance().map}
                geometry={object.geometry}
                tooltip={object.title}
            />
        );
    }

    onClusterRendered() {
        this.setState({loading: false});
    }

    onZoomLoad() {
        //this._cycleFetch && this._cycleFetch.forceNextWithDelay(300);
        this.loadTelematics();
    }

    async loadDictionaries(dictionaries, component = null) {
        _.each(dictionaries, async (dictionary) => {
            let documents = await this.getDictionary(dictionary, component);

            documents = dictionary === 'vehicle_types' ?  this.filterVehicleTypes(documents) : documents;

            dictionary === 'vehicle_types' ? window.vehicle_types = documents : null;

            let state = this.state;
            state[dictionary] = documents;
            this.setState(state);
        });
    }

    filterVehicleTypes(documents) {
        let arr = _.values(documents);
        return arr.filter((item) => {
            return item.component === 'kiutr' && item.name === 'Автобус' || item.name === 'Троллейбус' || item.name === 'Трамвай';
        });
    }

    async getDictionary(dictionary, component = null) {
        const response = await this.props.getDictionaryList(dictionary, {
            order: {
                column: 'name',
                direction: 'asc',
            },
            filters: {
                withComponent: component,
            },
        });
        if (response.isOk) {
            return _.keyBy(response.payload.documents, 'uuid');
        } else {
            response.showErrors();
        }
    }

    renderGarbageObjects() {
        if (!this.map || !this.map.refs.map) {
            return null;
        }

        return [
            <GarbageObjectsLayer
                key="kp"
                type="kp"
                map={this.map.refs.map}
                leafletMap={this.map.refs.map.getWrappedInstance().map}
            />,
            <GarbageObjectsLayer
                key="op"
                type="op"
                map={this.map.refs.map}
                leafletMap={this.map.refs.map.getWrappedInstance().map}
            />,
            <GarbageObjectsLayer
                key="opp"
                type="opp"
                map={this.map.refs.map}
                leafletMap={this.map.refs.map.getWrappedInstance().map}
            />,
            <GarbageObjectsLayer
                key="os"
                type="os"
                map={this.map.refs.map}
                leafletMap={this.map.refs.map.getWrappedInstance().map}
            />,
        ];
    }

    async closeStopPoint() {
        await this.setState({
            activeStopPoint: null,
            routes: [],
            fullScheduleRoute: null,
            fullScheduleRouteRun: null,
        });

        this.map.refs.map.getWrappedInstance().invalidateSize();
    }

    renderStopPointModal() {
        if (!this.state.activeStopPoint) {
            return null;
        }

        const buttons = (
            <ModalTopMenuButtons>
                <ModalTopMenuList className="top-menu_modal_edit">
                    <ModalTopMenuListItem
                        className="b-icon-link_icon_print"
                        onClick={::this.print}
                    />
                </ModalTopMenuList>
                <ModalTopMenuButton
                    className="_close"
                    onClick={::this.closeStopPoint}
                />
            </ModalTopMenuButtons>
        );

        const stopPoint = this.state.activeStopPoint;

        const title = (
            <div className="title">
                <div className="title__name">{stopPoint.title}</div>
                <div className="title__date">Движение на {this.state.stopPointTime.format(formats.DATETIME_SHORT)}</div>
            </div>
        );

        return [
            <PageModal
                key="stop-point"
                header={{titleFull: title, buttons}}
                withFade={false}
                className="b-modal-trip-planner-result b-modal-trip-planner-result-panel"
                onClose={::this.closeStopPoint}>
                {this.state.isRoutesLoading ? (<GlobalLoaderComponent/>) : null}
                <Accordion ref="stop-point">
                    {_.map(this.state.routes, ::this.renderStopPointRoute)}
                </Accordion>
            </PageModal>,
            this.state.fullScheduleRoute ? this.renderFullSchedule() : null,
        ];
    }

    print() {
        print(printSchedule(this.state.activeStopPoint, this.state.routes, this.state.stopPointRouteRuns));
    }

    renderStopPointRoute(route) {
        const {uuid, number, title, from, to, count, time} = route;

        const afterTitle = (
            <div className="accordion__dscn">
                <div className="accordion__route transport_info">
                    <div className="transport_icon">
                        <i className="transport_bus"/>
                    </div>
                    <span className="transport_number">{number}</span>
                    <div className="transport_route">
                        <span className="transport_route_start">{from}</span>
                        -
                        <span className="transport_route_finish">{to}</span>
                    </div>
                    <div className="transport_station">
                        <span className="transport_station-count">{count}</span> ост.
                        {(time !== -1) ? (
                            <i className="transport_station-icon" onClick={this.showFullSchedule.bind(this, uuid)}/>
                        ) : null}
                    </div>
                    <div className="transport_time">
                        {(time !== -1) ? ([
                            <span key="status" className="transport_status transport_status_tilda">~</span>,
                            <span key="time"
                                  className="transport_time-count">{formatTime(Math.round(time / 60))}</span>,
                        ]) : (
                            <span className="transport_time-count">-</span>
                        )}
                    </div>
                </div>
            </div>
        );

        const runs = _.filter(_.flatten(_.get(this.state.stopPointRouteRuns, uuid, [])));
        const lastPageRuns = _.get(this.state.stopPointRouteRuns, uuid + '.' + this.state.stopPointRoutePages[uuid], []);

        return (
            <AccordionItem key={route.uuid} afterTitle={afterTitle}
                           onOpened={this.loadStopPointRouteRuns.bind(this, uuid)}
                           collapsable={time !== -1}
                           withoutWrapper={time === -1}>
                {_.map(runs, this.renderRouteRun.bind(this, uuid))}
                {(time !== -1) ? (
                    <button className="transport_later"
                            title="Позже"
                            onClick={this.loadStopPointRouteRuns.bind(this, uuid, this.state.stopPointRoutePages[uuid] + 1)}>
                        <i className="transport_arrow transport_arrow_bottom"/>
                    </button>
                ) : null}
            </AccordionItem>
        );
    }

    focusOnRun(geometry) {
        this.map.refs.map.getWrappedInstance().fitBounds((new L.geoJSON(geometry)).getBounds(), {
            padding: new L.point(20, 20),
        });
    }

    async showFullSchedule(routeUuid) {
        await this.setState({
            fullScheduleRoute: routeUuid,
            fullScheduleRouteRun: null,
        });
        this.map.refs.map.getWrappedInstance().invalidateSize();
        const response = await this.props.getStopPointRouteRuns(this.state.activeStopPoint.uuid, routeUuid, null, true);

        if (response.isOk) {
            this.setState({
                fullScheduleRoute: routeUuid,
                fullScheduleRouteRun: _.first(response.payload.items),
            });
            this.focusOnRun(_.first(response.payload.items).geometry);
        } else {
            response.showErrors();
        }
    }

    async closeFullSchedule() {
        await this.setState({
            fullScheduleRoute: null,
            fullScheduleRouteRun: null,
        });
        this.map.refs.map.getWrappedInstance().invalidateSize();
    }

    renderFullSchedule() {
        const buttons = (
            <ModalTopMenuButtons>
                <ModalTopMenuButton
                    className="_close"
                    onClick={::this.closeFullSchedule}
                />
            </ModalTopMenuButtons>
        );

        const stopPoint = this.state.activeStopPoint;
        const run = this.state.fullScheduleRouteRun;
        const route = _.find(this.state.routes, {uuid: this.state.fullScheduleRoute});

        const title = (
            <div className="b-modal__name">Схема рейса
                <div className="b-modal__name-dscn font-weight-normal">
                    Через остановку <b>{stopPoint.title}</b> <br/>
                    по маршруту <b>{route.number}</b>
                </div>
            </div>
        );

        const stopPoints = _.sortBy(_.map(_.get(run, 'times') || [], (time, title) => {
            return {
                title,
                time,
            };
        }), ({time}) => {
            return time;
        });

        let position = 0;
        _.each(stopPoints, ({time, title}, index) => {
            if (title === stopPoint.title) {
                position = index + 1;
                return false;
            }
        });

        let content = null;
        if (run) {
            content = (
                <div className="b-modal__container">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="t-segment">
                                    <div className="t-segment__header">
                                        <div className="t-segment__header-row">
                                            <div className="t-segment__header-left">Протяженность</div>
                                            <div
                                                className="t-segment__header-right">{formatDistance(run.distance)}</div>
                                        </div>
                                        <div className="t-segment__header-row">
                                            <div className="t-segment__header-left">Продолжительность</div>
                                            <div className="t-segment__header-right">{formatTime(run.total_time)}</div>
                                        </div>
                                        <div className="t-segment__header-row">
                                            <div className="t-segment__header-left">Остановок до конечной</div>
                                            <div
                                                className="t-segment__header-right">{Math.max(0, stopPoints.length - position)}
                                                (всего - {stopPoints.length - 1})
                                            </div>
                                        </div>
                                    </div>
                                    <div className="t-segment__content">
                                        <div className="t-segment__content-right">
                                            {_.map(stopPoints, ({title, time}, index) => {
                                                if (index === 0) {
                                                    return (
                                                        <div key={index}
                                                             className={classNames('t-segment__point t-segment__point_start', {
                                                                 't-segment__point_start-current': index === position - 1,
                                                             })}>
                                                            <i className="p-result__icon p-result__icon_gray p-result__icon_border p-result__icon_wh24"/>
                                                            <div className="t-segment__point-text">{title}</div>
                                                            <div
                                                                className="t-segment__stops-item-time">{moment(time).format(formats.TIME)}</div>
                                                        </div>
                                                    );
                                                }

                                                if (index === stopPoints.length - 1) {
                                                    return (
                                                        <div key={index}
                                                             className={classNames('t-segment__point t-segment__point_final', {
                                                                 't-segment__point_final-current': index === position - 1,
                                                             })}>
                                                            <i className="p-result__icon p-result__icon_green p-result__icon_border p-result__icon_wh24"/>
                                                            <div className="t-segment__point-text">{title}</div>
                                                            <div
                                                                className="t-segment__stops-item-time">{moment(time).format(formats.TIME)}</div>
                                                        </div>
                                                    );
                                                }

                                                const stopPointBlock = (
                                                    <div key={index}
                                                         className={classNames('t-segment__stops-item', {})}>
                                                        <i className="p-result__icon p-result__icon_inner-green p-result__icon_wh24"/>
                                                        <div className="t-segment__stops-item-text">{title}</div>
                                                        <div
                                                            className="t-segment__stops-item-time">{moment(time).format(formats.TIME)}</div>
                                                    </div>
                                                );

                                                if (index < position - 1) {
                                                    return (
                                                        <div className="t-segment__stops t-segment__stops-no-active">
                                                            <div key={index}
                                                                 className={classNames('t-segment__stops-item', {})}>
                                                                <i className="p-result__icon p-result__icon_inner-gray p-result__icon_wh24"/>
                                                                <div
                                                                    className="t-segment__stops-item-text">{title}</div>
                                                                <div
                                                                    className="t-segment__stops-item-time">{moment(time).format(formats.TIME)}</div>
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                if (index === position - 1) {
                                                    return (
                                                        <div className="t-segment__stops t-segment__stops_current">
                                                            {stopPointBlock}
                                                        </div>
                                                    );
                                                }

                                                return stopPointBlock;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <PageModal
                key="stop-point-run"
                header={{titleFull: title, buttons}}
                withFade={false}
                className="b-modal-trip-planner-result tripStructure"
                onClose={::this.closeStopPoint}>
                {!run ? (<GlobalLoaderComponent/>) : null}
                {content}
            </PageModal>
        );
    }

    async showFullScheduleForRun(routeUuid, run) {
        await this.setState({
            fullScheduleRoute: routeUuid,
            fullScheduleRouteRun: run,
        });

        await this.map.refs.map.getWrappedInstance().invalidateSize();

        this.focusOnRun(this.getRunGeometry(run));
    }

    getRunGeometry(run) {
        let geometry = run.geometry;
        if (!geometry) {
            return geometry;
        }

        geometry.coordinates = _.filter(geometry.coordinates, (coordinates) => {
            return coordinates[0] !== 0 && coordinates[1] !== 0;
        });

        return geometry;
    }

    renderRouteRun(routeUuid, run, index) {
        const {time, end_at, times} = run;

        const diff = moment(time).diff(this.state.stopPointTime, 'minutes');

        return (
            <div key={index} className="transport_row" onClick={this.showFullScheduleForRun.bind(this, routeUuid, run)}>
                <span className="transport_status transport_status_tilda">~</span>
                <span className="transport_timetable">{moment(time).format(formats.TIME)}</span>
                {/*<span className="transport_time-after">(через {formatTime(diff)})</span>*/}
                <span className="transport_time-finitestate">
                    на конечной
                    <span className="transport_status transport_status_tilda">~</span>
                    {moment(end_at).format(formats.TIME)}
                    <span className="transport_question">
                        <div className="transport_question_prompt prompt">
                            {_.map(times, (time, title) => {
                                return (
                                    <div key={`${title}:${moment(time).format(formats.TIME)}`} className="prompt_row">
                                        <span>{title}</span>
                                        <span className="prompt_time">{moment(time).format(formats.TIME)}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </span>
                </span>
            </div>
        );
    }

    async loadStopPointRouteRuns(routeUuid, page = 1) {
        let stopPointRoutePages = this.state.stopPointRoutePages;
        stopPointRoutePages[routeUuid] = Math.max(stopPointRoutePages[routeUuid] || 1, page);

        if (_.get(this.state.stopPointRouteRuns, routeUuid + '.' + page)) {
            this.setState({stopPointRoutePages});
            return;
        }

        const response = await this.props.getStopPointRouteRuns(this.state.activeStopPoint.uuid, routeUuid, null, false, page);

        if (response.isOk) {
            let stopPointRouteRuns = this.state.stopPointRouteRuns;
            _.set(stopPointRouteRuns, routeUuid + '.' + page, response.payload.items);
            this.setState({stopPointRouteRuns, stopPointRoutePages});
        } else {
            response.showErrors();
        }
    }

    formatTime(seconds) {
        if (seconds === -1) {
            return '-';
        }
        if (seconds < 60) {
            return `через ${seconds} сек`;
        }
        const minutes = seconds / 60;
        if (minutes < 60) {
            return `через ${_.round(minutes)} мин`;
        }
        const hours = minutes / 60;
        if (hours < 24) {
            return `через ${_.round(hours)} ч`;
        }
        return `через ${_.round(hours / 24)} дн`;
    }

    async loadMo(type) {
        const meta = {
            filters: {
                withComponent: type
            }
        };
        const response = await this.props.listUserGeoObjectsMO(meta);

        if (response.isOk) {
            this.setState({
                mo: response.payload.items,
            });
        } else {
            response.showErrors();
        }
    }

    async getWorksDoneByMunicipalityUuid(communal_municipality_uuid) {
        let dateTo = moment().utcOffset(0);
        dateTo.set({hour:23,minute:59,second:0,millisecond:0});

        let dateFrom = moment().utcOffset(0);
        dateFrom.set({hour:0,minute:0,second:0,millisecond:0})

        let from_date = 0;
        let to_date = 0;

        switch (this.state.customDateSelected) {
            case 0:
                from_date = moment(dateFrom).subtract(1, 'd').format();
                to_date = moment(dateTo).subtract(1, 'd').format();
                break;
            case 1:
                from_date = moment(dateFrom).format();
                to_date = moment(dateTo).format();
                break;
            case 2:
                from_date = moment(dateFrom).add(1, 'd').format();
                to_date = moment(dateTo).add(1, 'd').format();
                break;
            default:
                from_date = moment(dateFrom).format();
                to_date = moment(dateTo).format();
        }

        const meta = {
            filters: {
                withPeriod: [from_date, to_date],
            }
        }

        if (this.state.selected_work_type !== 'all') {
            meta.filters.withWorkTypes = [this.state.selected_work_type]
        }

        if (communal_municipality_uuid || this.state.selected_communal_uuid) {
            meta.filters.withCommunalMunicipalities = communal_municipality_uuid ? [communal_municipality_uuid] : [this.state.selected_communal_uuid]
        }

        const response = await this.props.getTabletWorkSummary(meta);
        return response;
    }

    filteredByCommunalUuid(items, hasProperty) {
        return items.filter(item => 'communal_municipality_uuid' in item === hasProperty && item.hasOwnProperty('communal_municipality_uuid') === hasProperty);
    }

    async loadMu(type) {
        if (!this.state.mu) {
            const layers = await this.props.listLayers();
            const uuid = layers.payload.items.filter(layer => layer.title.includes('Муниципальные образования'))[0].uuid;
            const response = await this.props.listUserGeoObjectsByLayers({
                items: [uuid],
            });
            if (response.isOk) {
                const withCommunal = this.filteredByCommunalUuid(response.payload.items, true).sort((a, b) => a.title.toUpperCase() > b.title.toUpperCase() ? 1 : -1)
                const withoutCommunal = this.filteredByCommunalUuid(response.payload.items, false)
                const communalPromises = withCommunal.map(itemMu => itemMu)
                const resultWithCommunal = await Promise.all(communalPromises);
                await this.setState({
                    selector_municipalities: withCommunal,
                    mu: [...resultWithCommunal, ...withoutCommunal]
                });
                if (window.RNIS_SETTINGS.CITY_MURMANSK && withCommunal.length) {
                    const defaultMunicipality = withCommunal.filter(municipality => municipality.title === 'Городской округ Мурманск')[0];
                    await this.setState({
                        selected_communal_uuid: defaultMunicipality.communal_municipality_uuid
                    })
                }
            } else {
                response.showErrors();
            }
        }
    }

    async getGeometryFromContract() {
        let dateTo = moment().utcOffset(0);
        dateTo.set({hour:23,minute:59,second:0,millisecond:0});

        let dateFrom = moment().utcOffset(0);
        dateFrom.set({hour:0,minute:0,second:0,millisecond:0})

        let from_date = 0;
        let to_date = 0;

        switch (this.state.customDateSelected) {
            case 0:
                from_date = moment(dateFrom).subtract(1, 'd').format();
                to_date = moment(dateTo).subtract(1, 'd').format();
                break;
            case 1:
                from_date = moment(dateFrom).format();
                to_date = moment(dateTo).format();
                break;
            case 2:
                from_date = moment(dateFrom).add(1, 'd').format();
                to_date = moment(dateTo).add(1, 'd').format();
                break;
            default:
                from_date = moment(dateFrom).format();
                to_date = moment(dateTo).format();
        }
        const meta = {
            filters: {
                withPeriod: [from_date, to_date],
                withCommunalMunicipalities: ['cf68f132-f684-11ea-a75f-0252e77e7abb']
            }
        }
        if (this.state.selected_work_type !== 'all') {
            meta.filters.withWorkTypes = [this.state.selected_work_type]
        }
        if (this.state.selected_communal_uuid) {
            meta.filters.withCommunalMunicipalities = [this.state.selected_communal_uuid]
        }

        const response = await this.props.getGeometryFromContract(meta, {}, storage.get('user').token);
        let contracts = {};
        if (response.isOk) {
            if (response.payload && response.payload.items.length) {
                response.payload.items.forEach(itemContract => {
                    contracts[itemContract.uuid] = itemContract.contracts
                })
                const bluePolygonsRoadPartUuid = _.uniq(response.payload.items.map(item => item.uuid));
                await this.setState({
                    bluePolygonsRoadPartUuid,
                    contracts: contracts,
                    contractsToRender: response.payload.items,
                })
            }
        }
    }

    async loadMuRoadParts(communal_uuid) {
        await this.setState({
            muTasks: null,
            computedGeometry: null,
        })
        await this.getGeometryFromContract();
        localStorage.removeItem('renderMuContracts')
        localStorage.removeItem('renderMuRoadParts')
        let muTasksObjects = null;
        let dateTo = moment().utcOffset(0);
        dateTo.set({hour:23,minute:59,second:0,millisecond:0});

        let dateFrom = moment().utcOffset(0);
        dateFrom.set({hour:0,minute:0,second:0,millisecond:0})

        let from_date = 0;
        let to_date = 0;

        switch (this.state.customDateSelected) {
            case 0:
                from_date = moment(dateFrom).subtract(1, 'd').format();
                to_date = moment(dateTo).subtract(1, 'd').format();
                break;
            case 1:
                from_date = moment(dateFrom).format();
                to_date = moment(dateTo).format();
                break;
            case 2:
                from_date = moment(dateFrom).add(1, 'd').format();
                to_date = moment(dateTo).add(1, 'd').format();
                break;
            default:
                from_date = moment(dateFrom).format();
                to_date = moment(dateTo).format();
        }

        const meta = {
            filters: {
                withPeriod: [from_date, to_date],
            }
        }

        if (this.state.selected_work_type !== 'all') {
            meta.filters.withWorkTypes = [this.state.selected_work_type]
        }

        if (communal_uuid || this.state.selected_communal_uuid) {
            meta.filters.withCommunalMunicipalities = communal_uuid ? [communal_uuid] : [this.state.selected_communal_uuid]
        }

        const responseTasks = await this.props.getTasks(meta);
        if (responseTasks.isOk && responseTasks.payload.items.length) {
            muTasksObjects = responseTasks.payload.items
        } else {
            responseTasks.showErrors();
        }

        const response = await this.getWorksDoneByMunicipalityUuid(communal_uuid);

        if (response.isOk) {
            let localWorkTypes = {};
            if (response.payload.items) {
                const uniqueTasks = [...new Set(response.payload.items.map(task => task.work_type_uuid))];
                for (const work_type in this.state.work_types) {
                    if (uniqueTasks.includes(work_type)) {
                        localWorkTypes[work_type] = this.state.work_types[work_type]
                    }
                }
            }

            this.setState({
                filter_work_types: Object.keys(localWorkTypes).length ? localWorkTypes : null,
                muTasksObjects: muTasksObjects,
                muTasks: response.payload.items.length ? response.payload.items : null,
                isNeedContractRender: response.payload.items.length ? false : true,
            })
        } else {
            response.showErrors();
        }
    }

    renderMu() {
        return _.map(this.state.mu, (item, index) => {
            return (
                <MapGeojson
                    fillOpacity={0}
                    opacity={1}
                    color="#EEDDD9"
                    bringToBack={item.geometry.coordinates[0].length > 200 ? true : false}
                    key={item.uuid}
                    map={this.map.refs.map}
                    leafletMap={this.map.refs.map.getWrappedInstance().map}
                    geometry={item.geometry}
                />
            )
        });
    }

    logicForGeoJsonObjectColor(factCount, planCount, is_end) {
        if (factCount === planCount && planCount !== 0) {
            return 'green'
        }
        if (factCount < planCount && factCount !== 0 && planCount !== 0) {
            if (is_end) {
                return 'white'
            } else {
                return 'yellow'
            }
        }
        if (factCount < planCount && factCount === 0 && planCount > 0) {
            if (is_end === false) {
                return 'grey'
            } else {
                return 'red'
            }
        }
        if (factCount > planCount && factCount !== 0 && planCount !== 0) {
            return 'green'
        }
        return 'none'
    }

    computeSummaryCountConfirmedTaskEnd(items_fact, items_plan, blue) {
        let factCount = 0;
        let planCount = 0;
        const is_confirmed = items_fact.length && Object.keys(items_fact[0]).includes('is_confirmed') ? items_fact[0].is_confirmed : false;
        const time = items_fact.length ? items_fact[0].time_to : items_plan[0].time_to;
        const date = items_fact.length ? items_fact[0].date : items_plan[0].date;
        const hours = time.split(':')[0];
        const minutes = time.split(':')[1];
        const dateOfItem = moment(date).set({hour: hours, minute: minutes});
        const is_end = dateOfItem.isBefore(moment()) ? true : false;

        if (items_fact.length) {
            factCount = items_fact.reduce((acc, item) => {
                if (item.count) {
                    return acc + item.count
                } else {
                    return acc
                }
            }, 0)
        }
        if (items_plan.length) {
            planCount = items_plan.reduce((acc, item) => {
                if (item.count) {
                    return acc + item.count
                } else {
                    return acc
                }
            }, 0)
        }
        let color = this.logicForGeoJsonObjectColor(factCount, planCount, is_end);
        if (color === 'none' && blue) {
            color = 'blue'
        }
        let result = {factCount, planCount, is_confirmed: is_confirmed, color: color}
        if (blue) {
            result['colorBlue'] = true
        }
        return result
    }

    async onChangeWorkType(field, e) {
        const value = e.value || e.target.value;
        await this.setState({
            selected_work_type: value,
        });
        this.loadMuRoadParts();
    }

    renderWorkTypeSelect() {
        let work_types;
        if (this.state.filter_work_types) {
            const customWorkTypes = Object.keys(this.state.filter_work_types).length ? this.state.filter_work_types : this.state.work_types;
            work_types = {...{'000f000': { uuid: 'all', name: 'Все виды работ' }}, ...customWorkTypes,  }
        } else {
            work_types = {...{'000f000': { uuid: 'all', name: 'Все виды работ' }}, ...this.state.work_types,  }
        }


        return (
            <div className="select-workType">
                <Select
                    name="form-field-name"
                    options={_.map(work_types, (work_type) => ({
                        value: work_type.uuid,
                        label: work_type.name
                    }))}
                    value={this.state.selected_work_type}
                    clearable={false}
                    onChange={this.onChangeWorkType.bind(this, 'work_type')}
                />
            </div>
        );
    }

    async customPickerSelect(dateSelected) {
        await this.setState({
            customDateSelected: dateSelected
        });
        this.loadMuRoadParts();
    }

    renderCustomDatePicker() {
        return <div className="select-customDateSelect">
            <div className="select-customDateSelect-body">
                <p onClick={() => this.customPickerSelect(0)} className={classNames('select-customDateSelect-item', this.state.customDateSelected === 0 && 'select-customDateSelect-item_active')}>Вчера</p>
                <span className="select-customDateSelect-hr"></span>
                <p onClick={() => this.customPickerSelect(1)} className={classNames('select-customDateSelect-item', this.state.customDateSelected === 1 && 'select-customDateSelect-item_active')}>Сегодня</p>
                <span className="select-customDateSelect-hr select-customDateSelect-hr_last"></span>
                <p onClick={() => this.customPickerSelect(2)} className={classNames('select-customDateSelect-item', this.state.customDateSelected === 2 && 'select-customDateSelect-item_active')}>Завтра</p>
            </div>
        </div>
    }

    setPositionAndZoomMunicipality(label) {
        const selectedCommunal = this.state.selector_municipalities.filter(item => item.title === label)[0];
        const __layer = new L.GeoJSON(selectedCommunal.geometry, {});
        if (label.includes('Апатиты')) {
            this.map.refs.map.getWrappedInstance().map.setView(new L.LatLng(67.568023, 33.407187), 11);
        } else {
            const polygonCenter = __layer.getBounds().getCenter();
            this.map.refs.map.getWrappedInstance().map.setView(new L.LatLng(polygonCenter.lat, polygonCenter.lng), 11);
        }

    }

    renderMunicipalities() {
        return <div className="select-municipalitySelect">
            <Select
                options={_.map(this.state.selector_municipalities, (municipality) => ({
                    value: municipality.communal_municipality_uuid,
                    label: municipality.title
                }))}
                value={this.state.selected_communal_uuid}
                clearable={false}
                placeholder={'Выбрать город'}
                onChange={async (e) => {
                    const value = e ? e.value : null;
                    await this.setState({
                        selected_communal_uuid: value,
                    });
                    this.setPositionAndZoomMunicipality(e.label);
                    this.loadMuRoadParts();
                }}
            />
        </div>
    }

    getPriorityColor(arrayWithColors) {
        if (arrayWithColors.includes('green')) {
            return 'green';
        }
        if (arrayWithColors.includes('grey')) {
            return 'grey';
        }
        if (arrayWithColors.includes('yellow')) {
            return 'yellow';
        }
        if (arrayWithColors.includes('red')) {
            return 'red';
        }
        if (arrayWithColors.includes('blue')) {
            return 'blue';
        }
    }



    renderMuContracts() {
        if (!localStorage.getItem('renderMuContracts')) {
            const geometry = this.state.contractsToRender.map((item, key) => {
                return <MapGeojson
                    color={"blue"}
                    key={_.uniqueId(key)}
                    map={this.map.refs.map}
                    leafletMap={this.map.refs.map.getWrappedInstance().map}
                    geometry={item.geometry}
                />
            });
            localStorage.setItem('renderMuContracts', true);
            this.setState({
                computedGeometry: geometry
            })
            return geometry;
        } else {
            return this.state.computedGeometry;
        }
    }

    renderMuRoadParts() {
        if (!localStorage.getItem('renderMuRoadParts')) {
            const relationsUniqueNumbers = _.uniq(this.state.muTasks.map(task => task.relation_number));

            let collection = {};
            let earlyCollection = {};
            let priorityCollectionColors = {};

            //первоначальная закраска
            relationsUniqueNumbers.forEach(relationNumber => {
                const relationNumberPairs = this.state.muTasks.filter(task => task.relation_number === relationNumber);
                const item_fact = relationNumberPairs.filter(item => item.type === 'fact')
                const item_plan = relationNumberPairs.filter(item => item.type === 'plan')
                const roadPartUuidToCheckInBlueColors = item_fact[0] ? item_fact[0].road_part_uuid : item_plan[0].road_part_uuid;
                const polygonUuidToCheckInBlueColors = item_fact[0] ? item_fact[0].user_geo_object_uuid : item_plan[0].user_geo_object_uuid;

                let blue = false;
                if (roadPartUuidToCheckInBlueColors && this.state.bluePolygonsRoadPartUuid && this.state.bluePolygonsRoadPartUuid.includes(roadPartUuidToCheckInBlueColors)) {
                    blue = true;
                }
                if (polygonUuidToCheckInBlueColors && this.state.bluePolygonsRoadPartUuid && this.state.bluePolygonsRoadPartUuid.includes(polygonUuidToCheckInBlueColors)) {
                    blue = true;
                }
                const service_info = this.computeSummaryCountConfirmedTaskEnd(item_fact, item_plan, blue);
                collection[relationNumber] = {
                    item_fact: item_fact.date ? item_fact : item_fact[0],
                    item_plan: item_plan.date ? item_plan : item_plan[0],
                    service_info
                }

                const itemDate = collection[relationNumber].item_fact ? collection[relationNumber].item_fact.date : collection[relationNumber].item_plan.date;
                const roadPartUuid = collection[relationNumber].item_fact ? collection[relationNumber].item_fact.road_part_uuid : collection[relationNumber].item_plan.road_part_uuid;
                const polygonPartUuid = collection[relationNumber].item_fact ? collection[relationNumber].item_fact.user_geo_object_uuid : collection[relationNumber].item_plan.user_geo_object_uuid;

                const resultPartUuid = roadPartUuid ? roadPartUuid : polygonPartUuid;
                collection[relationNumber].partUuid = resultPartUuid;

                const roadPartDay = moment(itemDate);
                const todayDate = moment();
                if (moment(moment(roadPartDay).format('DD.MM.YYYY')).isBefore(moment(todayDate).format('DD.MM.YYYY'))) {
                    let roadPartUuidArray = earlyCollection[resultPartUuid] ? earlyCollection[resultPartUuid] : [];
                    let roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
                    roadPartUuidArray.push(collection[relationNumber].service_info.color);
                    roadPartUuidArrayPriority.push(collection[relationNumber].service_info.color);
                    if (collection[relationNumber].service_info['colorBlue']) {
                        roadPartUuidArrayPriority.push('blue');
                    }
                    earlyCollection[resultPartUuid] = [...new Set(roadPartUuidArray)];
                    priorityCollectionColors[resultPartUuid] = [...new Set(roadPartUuidArrayPriority)];
                } else {
                    let roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
                    roadPartUuidArrayPriority.push(collection[relationNumber].service_info.color);
                    if (collection[relationNumber].service_info['colorBlue']) {
                        roadPartUuidArrayPriority.push('blue');
                    }
                    priorityCollectionColors[resultPartUuid] = roadPartUuidArrayPriority;
                }
            });

            //закраска не однозначных цветов, которые надо проверить, есть ли в прошлом для них road_part_uuid, которые green, red или оба
            // если не совпало в прошлом, либо прошлых вообще нет - то тогда остается красным цветом
            for (const item in collection) {
                const roadPartUuid = collection[item].item_fact ? collection[item].item_fact.road_part_uuid : collection[item].item_plan.road_part_uuid;
                const polygonPartUuid = collection[item].item_fact ? collection[item].item_fact.user_geo_object_uuid : collection[item].item_plan.user_geo_object_uuid;
                const resultPartUuid = roadPartUuid ? roadPartUuid : polygonPartUuid;

                if (collection[item].service_info.color === 'white') {
                    if (earlyCollection[resultPartUuid]) {
                        if (earlyCollection[resultPartUuid].includes('green') && earlyCollection[resultPartUuid].includes('red')) {
                            collection[item].service_info.color = 'yellow'
                            let roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
                            roadPartUuidArrayPriority.push('yellow');
                            priorityCollectionColors[resultPartUuid] = roadPartUuidArrayPriority.filter(item => item !== 'white');
                        }
                        if (earlyCollection[resultPartUuid].includes('green') && !earlyCollection[resultPartUuid].includes('red') || earlyCollection[resultPartUuid].includes("red") && !!earlyCollection[resultPartUuid].includes("green")) {
                            collection[item].service_info.color = 'yellow'
                            let roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
                            roadPartUuidArrayPriority.push('yellow');
                            priorityCollectionColors[resultPartUuid] = roadPartUuidArrayPriority.filter(item => item !== 'white');
                        }
                        collection[item].service_info.color = 'red'
                        let roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
                        roadPartUuidArrayPriority.push('red');
                        priorityCollectionColors[resultPartUuid] = roadPartUuidArrayPriority.filter(item => item !== 'white');
                    } else {
                        collection[item].service_info.color = 'red';
                        let roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
                        roadPartUuidArrayPriority.push('red');
                        priorityCollectionColors[resultPartUuid] = roadPartUuidArrayPriority.filter(item => item !== 'white');
                    }
                }
            }

            //закраска с учетом приоритета цветов
            for (const item in collection) {
                const roadPartUuid = collection[item].item_fact ? collection[item].item_fact.road_part_uuid : collection[item].item_plan.road_part_uuid;
                const polygonPartUuid = collection[item].item_fact ? collection[item].item_fact.user_geo_object_uuid : collection[item].item_plan.user_geo_object_uuid;
                const resultPartUuid = roadPartUuid ? roadPartUuid : polygonPartUuid;
                collection[item].service_info.color = this.getPriorityColor(priorityCollectionColors[resultPartUuid])
            }

            const contractsGeometry = this.state.contractsToRender.map((contract, key) => {
                const color = priorityCollectionColors[contract.uuid] ? this.getPriorityColor(priorityCollectionColors[contract.uuid]) : 'blue';
                return <MapGeojson
                    color={color}
                    opacity={color === 'blue' && contract.geometry.type === 'Polygon' ? 0.6 : 1}
                    key={_.uniqueId(key)}
                    map={this.map.refs.map}
                    leafletMap={this.map.refs.map.getWrappedInstance().map}
                    geometry={contract.geometry}
                />
            })

            const geometry = Object.keys(collection).map(key => {
                    let fact = [];
                    let plan = [];
                    if (collection[key].item_fact && collection[key].item_fact.geojson && collection[key].service_info.color) {
                        fact = [<MapGeojson
                            color={collection[key].service_info.color}
                            opacity={collection[key].item_fact.geojson.type === "Polygon" ? 0.6 : 1}
                            key={_.uniqueId(key)}
                            map={this.map.refs.map}
                            leafletMap={this.map.refs.map.getWrappedInstance().map}
                            geometry={collection[key].item_fact.geojson}
                        />];
                    }

                    if(collection[key].item_plan && collection[key].item_plan.geojson && collection[key].service_info.color) {
                        plan = [<MapGeojson
                            color={collection[key].service_info.color}
                            opacity={collection[key].item_plan.geojson.type === "Polygon" ? 0.6 : 1}
                            key={_.uniqueId(key)}
                            map={this.map.refs.map}
                            leafletMap={this.map.refs.map.getWrappedInstance().map}
                            geometry={collection[key].item_plan.geojson}
                        />];
                    }

                    return [...fact, ...plan];
                });
            localStorage.setItem('renderMuRoadParts', true);
            this.setState({
                computedGeometry: [...geometry, ...contractsGeometry]
            })
            console.info('Collection', collection);
            console.info('EarlyCollection', earlyCollection);
            console.info('PriorityCollectionColors', priorityCollectionColors);
            return [...geometry, ...contractsGeometry];
        } else {
            return this.state.computedGeometry;
        }
    }

    renderMo() {
        if (this.props.params.type !== 'garbage' && this.props.params.type !== 'road') {
            return null;
        }

        if (!this.map) {
            return;
        }

        return _.map(this.state.mo, (item) => {
            return (
                <MapGeojson
                    key={item.uuid}
                    map={this.map.refs.map}
                    leafletMap={this.map.refs.map.getWrappedInstance().map}
                    geometry={item.geometry}
                    tooltip={`<h3 style="text-align: center">${item.title} </h3><p>${item.org_name ? item.org_name : ''}</p> <p>${item.phone ? item.phone : ''}</p> <p>${item.email ? item.email : ''}</p>`}
                />
            )
        });
    }

    renderRoute() {
        if (!this.state.fullScheduleRoute) {
            return null;
        }

        const run = this.state.fullScheduleRouteRun;
        if (!run || !run.geometry) {
            return null;
        }

        return (
            <MapGeojson
                map={this.map.refs.map}
                leafletMap={this.map.refs.map.getWrappedInstance().map}
                geometry={this.getRunGeometry(run)}
            />
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/modules/map/map.js